import { ACCOUNT_FEATURE_FLAGS } from "@/constants";
import { Account } from "@/types";
import { computed, toRef, type ComputedRef, type MaybeRef } from "vue";

/**
 * Composable for checking and managing account feature flags
 *
 * @param account - The account object (can be reactive or plain)
 * @returns Object with utilities for feature flag management
 */
export function useAccountFeatureFlags(
  account: MaybeRef<Account | null | undefined>
) {
  const accountRef = toRef(account);

  /**
   * Check if the account has a specific feature flag enabled
   *
   * @param flagKey - The feature flag key to check
   * @returns Reactive boolean indicating if the flag is enabled
   */
  const hasFlag = (
    flagKey: keyof typeof ACCOUNT_FEATURE_FLAGS
  ): ComputedRef<boolean> => {
    return computed(() => {
      const currentAccount = accountRef.value;
      if (!currentAccount?.feature_flags) return false;
      return currentAccount.feature_flags[flagKey] === true;
    });
  };

  return {
    hasFlag,
  };
}
